// Constants for the Listening Ear visit-note workflow.
// These two fields (Encounter Topic + Resolution) apply to the Listening Ear
// care type ONLY — not to Offsite Transfers, which reuses the same component.

export interface ListeningEarOption {
  label: string;
  value: string;
}

// Encounter Topic — "check all that apply" multi-select.
// Topics marked with `*` may require escort/reporting to another resource
// (see ESCORT_LEGEND). The `*` is kept in the label so it renders in the list.
export const ENCOUNTER_TOPIC_OPTIONS: ListeningEarOption[] = [
  { label: "Adult/ Leader Concern", value: "Adult/ Leader Concern" },
  { label: "Cultural Conflict", value: "Cultural Conflict" },
  {
    label: "Devotional/ Spiritual Resources *",
    value: "Devotional/ Spiritual Resources",
  },
  {
    label: "Faith & Beliefs Information *",
    value: "Faith & Beliefs Information",
  },
  { label: "Homesick/Lonely", value: "Homesick/Lonely" },
  { label: "Hygiene Concerns", value: "Hygiene Concerns" },
  { label: "Interpersonal Conflict", value: "Interpersonal Conflict" },
  { label: "Mental Health Topic *", value: "Mental Health Topic" },
  {
    label: "Offsite Concerns (ie. Family Topic)",
    value: "Offsite Concerns (ie. Family Topic)",
  },
  { label: "Physical Distress (Health) *", value: "Physical Distress (Health)" },
  { label: "Rest & Relaxation", value: "Rest & Relaxation" },
  { label: "Rule/Security Violation *", value: "Rule/Security Violation" },
  { label: "Sexual Issue", value: "Sexual Issue" },
  { label: "Sleep Issues", value: "Sleep Issues" },
  {
    label: "Other (Add Details in Subjective Note)",
    value: "Other (Add Details in Subjective Note)",
  },
];

export const ESCORT_LEGEND =
  "* May require escort/reporting to other resource";

// Resolution (Disposition) — single-select, mirrors the discharge workflow
// with Listening-Ear-specific options.
export const RESOLUTION_OPTIONS: ListeningEarOption[] = [
  { label: "Resolved by Listening Ear", value: "Resolved by Listening Ear" },
  { label: "Resolved by Chaplains", value: "Resolved by Chaplains" },
  { label: "Transfer to Clinic", value: "Transfer to Clinic" },
  { label: "Referred to Faith & Beliefs", value: "Referred to Faith & Beliefs" },
  { label: "Referred to Commissioners", value: "Referred to Commissioners" },
  {
    label: "Referred to Base Camp Operations",
    value: "Referred to Base Camp Operations",
  },
  { label: "Refused Further Assistance", value: "Refused Further Assistance" },
];
